module.exports = "/assets/eb494b8063030aa81be5efba4b380347.svg";